(function () {
  function parseTargetValue(raw) {
    if (raw == null) return null;
    const cleaned = String(raw).trim().replace(/,/g, '');
    const value = Number(cleaned);
    if (Number.isNaN(value)) return null;
    const decimalMatch = cleaned.match(/\.(\d+)/);
    const decimals = decimalMatch ? decimalMatch[1].length : 0;
    return { value, decimals };
  }

  function formatValue(value, decimals) {
    if (!decimals) return String(Math.round(value));
    return value.toFixed(decimals);
  }

  function animateCountUp(element) {
    if (!element || element.dataset.countUpDone === 'true') return;

    const rawTarget = element.dataset.quantity ?? element.textContent;
    const parsed = parseTargetValue(rawTarget);
    if (!parsed) return;

    element.dataset.countUpDone = 'true';

    const durationMs = Number(element.dataset.countUpDuration || 1200);
    const startValue = 0;
    const targetValue = parsed.value;
    const decimals = parsed.decimals;
    const startTime = performance.now();

    element.textContent = formatValue(startValue, decimals);

    function tick(now) {
      const progress = Math.min(1, (now - startTime) / durationMs);
      const currentValue = startValue + (targetValue - startValue) * progress;
      element.textContent = formatValue(currentValue, decimals);
      if (progress < 1) requestAnimationFrame(tick);
      else element.textContent = String(element.dataset.quantity ?? rawTarget).trim();
    }

    requestAnimationFrame(tick);
  }

  function initCountUp(root) {
    const scope = root || document;
    const quantityElements = scope.querySelectorAll('.text-quantity');
    if (!quantityElements.length) return;

    if (!('IntersectionObserver' in window)) {
      quantityElements.forEach(animateCountUp);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCountUp(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.45 }
    );

    quantityElements.forEach(function (element) {
      if (element.dataset.countUpObserved === 'true') return;
      element.dataset.countUpObserved = 'true';
      observer.observe(element);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountUp(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCountUp(event.target);
  });
})();